module.exports = __webpack_public_path__ + "static/img/GongZuoLiangGuanKongJiaShiCang.96acee17.jpg";